import React from "react";
import styled from "styled-components";

const ProgressBarContainer = styled.div`
   display: flex;
   align-items: center;
   height: 8px; /* Height of the progress bar */
   gap: 1px; /* Space between segments */
`;

const ProgressSegment = styled.div.withConfig({
   shouldForwardProp: (prop) => !["isLast", "isFirst", "isCompleted", "isPartial", "partialPercent"].includes(prop),
})`
   width: ${({ width }) => `${width}px`}; /* Width of each segment */
   height: 8px; /* Height of the progress bar */
   background: ${({ isCompleted, isPartial, partialPercent }) =>
      isCompleted
         ? "#689f38" // Fully completed segments
         : isPartial
         ? `linear-gradient(to right, #689f38 ${partialPercent}%, #e0e0e0 ${partialPercent}%)` // Partially filled
         : "#e0e0e0"}; // Incomplete segments
   border-radius: ${({ isFirst, isLast }) => (isFirst ? "8px 0 0 8px" : isLast ? "0 8px 8px 0" : "0")}; /* Rounded corners */
`;

const ProgressBar = ({ completion, isLoading }) => {
   const totalSegments = 5;
   const segmentWidth = 30; // Width of each segment
   const segmentPercentage = 100 / totalSegments; // Percentage per segment
   const fullSegments = Math.floor(completion / segmentPercentage); // Fully completed segments
   const partialPercent = ((completion % segmentPercentage) / segmentPercentage) * 100; // Partial completion percentage

   return (
      <ProgressBarContainer>
         {Array.from({ length: totalSegments }).map((_, index) => {
            if (isLoading) {
               return (
                  <div
                     key={index}
                     className="placeholder-glow"
                     style={{
                        width: `${segmentWidth}px`,
                        height: "8px",
                        overflow: "hidden",
                        borderRadius: index === 0 ? "8px 0 0 8px" : index === totalSegments - 1 ? "0 8px 8px 0" : "0",
                     }}>
                     <span
                        className="placeholder"
                        style={{
                           display: "block", // Override the default `inline-block`
                           height: "100%", // Ensure it fills the parent height
                           width: "100%", // Ensure it fills the parent width
                        }}></span>
                  </div>
               );
            }

            const isCompleted = index < fullSegments; // Fully green segments
            const isPartial = index === fullSegments && partialPercent > 0; // Partially filled segment

            return <ProgressSegment key={index} width={segmentWidth} isCompleted={isCompleted} isPartial={isPartial} partialPercent={partialPercent} isFirst={index === 0} isLast={index === totalSegments - 1} />;
         })}
      </ProgressBarContainer>
   );
};

export default ProgressBar;
